export default {
    GETOFFICES: '@_get_offices',
    ADDOFFICE: '@_add_office',
};
